import type { Instant } from "@js-joda/core";
import { ConvertToInstant } from "src/utilities/DateUtils";

export interface Contact {
  // Info
  email: string;
  webSite: string;

  // Address
  address1: string;
  address2?: string;
  city: string;
  regionCode: string;
  countryCode: string;
  postalCode: string;

  // Contact
  contactFirstName: string;
  contactLastName: string;
  contactTitle?: string;
  phoneNumber1?: string;
  phoneExt1?: string;
  phoneNumber2?: string;
  phoneExt2?: string;
  mobileNumber?: string;
  faxNumber?: string;

  // Language Zone
  languageCode?: string;
  timeZone?: string;
}

/**
 * @deprecated
 */
export default class ContactClass implements Contact {
  // Info
  public email: string;
  public webSite: string;

  // Address
  public address1: string;
  public address2: string;
  public city: string;
  public regionCode: string;
  public countryCode: string;
  public postalCode: string;

  // Contact
  public contactFirstName: string;
  public contactLastName: string;
  public contactTitle: string;
  public phoneNumber1: string;
  public phoneExt1: string;
  public phoneNumber2: string;
  public phoneExt2: string;
  public mobileNumber: string;
  public faxNumber: string;

  // Language Zone
  public languageCode: string;
  public timeZone: string;

  // Time
  public firstCreated: Instant;
  public lastUpdated: Instant;

  constructor(obj?: any) {
    if (obj) {
      this.email = obj.email;
      this.webSite = obj.webSite;
      this.address1 = obj.address1;
      this.address2 = obj.address2;
      this.city = obj.city;
      this.regionCode = obj.regionCode;
      this.countryCode = obj.countryCode;
      this.postalCode = obj.postalCode;
      this.contactFirstName = obj.contactFirstName;
      this.contactLastName = obj.contactLastName;
      this.contactTitle = obj.contactTitle;
      this.phoneNumber1 = obj.phoneNumber1;
      this.phoneExt1 = obj.phoneExt1;
      this.phoneNumber2 = obj.phoneNumber2;
      this.phoneExt2 = obj.phoneExt2;
      this.mobileNumber = obj.mobileNumber;
      this.faxNumber = obj.faxNumber;
      this.languageCode = obj.languageCode;
      this.timeZone = obj.timeZone;
      this.firstCreated = ConvertToInstant(obj.firstCreated);
      this.lastUpdated = ConvertToInstant(obj.lastUpdated);
    }
  }
}
